import styled from "styled-components";

const MOBILE_BREAKPOINT = "768px";

export const FilterRowContainer = styled.div`
    position: absolute;
    z-index: 10;
    width: 100%;
    top: 0;
    left: 0;
    pointer-events: auto;
`;

export const FilterRow = styled.div`
    margin: 0 auto !important;
    padding: 10px 20px;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
`;

export const MapContainer = styled.div`
    width: 100%;
    height: ${props => (props.mode === "fixed" ? "80vh" : "calc(100vh - 120px)")};
    overflow: hidden;
    border: 2px solid #aef001;
    border-radius: 4px;
    z-index: 10;
    position: relative;
    display: flex;
    flex-direction: column;
    background: white;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    margin: 16px 0;


    /* Google Maps container styling */
    .google-map-react {
        border-radius: 14px;
        overflow: hidden;
    }

    /* Custom scrollbar for better UX */
    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
        background: #aef001;
        border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: #9edf00;
    }

    ${({mode}) =>
        mode === "fixed" &&
        `position: fixed;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 90vw;
        height: 80vh;
        z-index: 9999;
        border: 2px solid #aef001;
        border-radius: 8px;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
        background: white;
        margin: 0;`}

    /* Mobile responsive design */
    @media (max-width: ${MOBILE_BREAKPOINT}) {
        height: ${props => (props.mode === "fixed" ? "80vh" : "calc(100vh - 80px)")};
        border-radius: 12px;
        margin: 12px 0;
        border-width: 1px;

        &:hover {
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
            border-color: #f0f0f0;
        }
    }

    /* Tablet responsive design */
    @media (min-width: 769px) and (max-width: 1024px) {
        height: ${props => (props.mode === "fixed" ? "80vh" : "calc(100vh - 100px)")};
        border-radius: 14px;
        margin: 14px 0;
    }

    /* Large screen optimization */
    @media (min-width: 1440px) {
        height: ${props => (props.mode === "fixed" ? "80vh" : "calc(100vh - 300px)")};
        border-radius: 18px;
        margin: 18px 0;
    }
`;

export const MapTools = styled.button`
    width: 32px;
    height: 32px;
    position: absolute;
    z-index: 10000;
    background: #fff;
    right: 10px;
    top: 10px;
    box-shadow: rgb(0 0 0 / 30%) 0px 1px 4px -1px;
    border-radius: 2px;
    padding: 0;
    border: 1px solid #d9d9d9;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        width: 1.5em;
        height: 1.5em;
    }

    &:hover {
        background: #f5f5f5;
        border-color: #40a9ff;
    }
`;
